module.exports = __webpack_public_path__ + "img/profile-check.50688ae5.svg";